import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Klaviyo links can arrive with the query string encoded into the path
 * (e.g. `/my-ratings%3F_kx=...`), which matches no route. Decode the path
 * before parsing so they resolve to `/my-ratings?_kx=...`.
 *
 * Usage (app.config.ts):
 *   { provide: UrlSerializer, useClass: EncodedUrlSerializer }
 */
export class EncodedUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return super.parse(decodeEncodedQuery(url));
  }
}

function decodeEncodedQuery(url: string): string {
  const pathEnd = url.search(/[?#]/);
  const path = pathEnd === -1 ? url : url.slice(0, pathEnd);
  if (!/%3F/i.test(path)) return url;

  let decodedPath: string;
  try {
    decodedPath = decodeURIComponent(path);
  } catch {
    return url; // Malformed encoding: leave it to the router as-is.
  }

  const rest = pathEnd === -1 ? '' : url.slice(pathEnd);
  // If the decoded path now carries a query, merge any real one into it.
  const joinedRest =
    decodedPath.includes('?') && rest.startsWith('?')
      ? `&${rest.slice(1)}`
      : rest;
  return decodedPath + joinedRest;
}
